import React from "react";
import "./AboutPage.css";
import AboutIMG from "../../assets/avatar-2.svg";
import AboutBox from "./AboutBox";
import QuoteSign from"../../assets/quote.png"
import Resume from "../../assets/CHHORNSeyha(CV).jpg";
// Import your icons here
import HtmlIcon from "../../assets/html.png";
import CssIcon from "../../assets/java.png";
import JavaIcon from "../../assets/css-3.png";
import ReactIcon from "../../assets/docker.png";
import PhotoshopIcon from "../../assets/postgre.png";
import IllustratorIcon from "../../assets/database.png";
import ReactJs from "../../assets/atom.png";
import SpringBoot from "../../assets/Spring_Boot.svg.png";
import JsLogo from "../../assets/js.png";
import AmazonAws from "../../assets/amazon+aws-1331550885897517282.png";


const AboutPage = () => {
  const skills = [
    { name: "HTML", percentage: "80%" },
    { name: "CSS", percentage: "50%" },
    { name: "Java", percentage: "70%" },
    { name: "Spring boot", percentage: "60%" },
    { name: "React JS", percentage: "50%" },
    { name: "Photoshop", percentage: "70%" },
    { name: "Illustrator", percentage: "60%" },
  ];

  const icons = [
    HtmlIcon,
    CssIcon,
    JavaIcon,
    ReactIcon,
    PhotoshopIcon,
    IllustratorIcon,
    ReactJs,
    SpringBoot,
    JsLogo,
    AmazonAws,
  ];

  return (
    <section className="about container section dark:bg-gray-800" id="about">
      <h2 className="section__title dark:text-white">About Me</h2>
      <div className="about__container grid">
        <img src={AboutIMG} alt="About Me" className="about__img" />

        <div className="about__data">
          <div className="about__info">
            <p className="about__description">
           <span><img className="w-5 h-5 absolute top-2 left-2 m-10 " src={QuoteSign} alt="QuoteSign" /></span> 안녕하세요. 제 이름은 천세이하 입니다. 현재 컴퓨터공학을 전공하고 있으며, Korean Software HRD 센터에서 ITE 13기로 공부하고 있습니다. 새로운 도전에 제 역량을 발휘하고, 효과적으로 기여하는 동시에 개인적으로 그리고 전문적으로 지속적으로 성장하고자 합니다.
            <br /> <br /> 
              Driven by a passion for making a positive impact, I have cultivated
              strong leadership, communication, and teamwork skills through
              extensive volunteer work with youth organizations. I am eager to
              apply these abilities to new challenges, contributing effectively
              while continuing to grow both personally and professionally. 
              
              {/* -안녕하세요. 제 이름은 천세이하 입니다. 저는 컴퓨터공학을 전공하고 있으며, 현재 Korean Software HRD 센터에서 ITE 13기 학생으로 꿈을 향해 나아가고 있습니다. */}

            </p>
            
            <a
            id="Cv__Btn"
            href={Resume}// Use the imported Resume path here
            download="ChhornseyhaCv"// Specify the name you want the downloaded file to have
            className="btn cv"
          >   
            Download CV
          </a>
          
            <div className="icon_skill">  
              {/* Display Icons */}
              {icons.map((icon, index) => (
                <div key={index} className="icon">
                  <img src={icon} alt={`icon-${index}`} className="icon__image" />
                </div>
              ))}
            </div>
          </div>
            {/* Skills Section */}
          <div className="about__skills grid ">
          
            {skills.map((skill, index) => (
              <div key={index} className="skills__data ">
                <div className="skills__title ">
                  <h3 className="skills__name ">{skill.name}</h3>
                  <span className="skill__numbers">{skill.percentage}</span>
                </div>
                <div className="skills__bar">
                  <span
                    className="skills__percentage"
                    style={{ "--skill-percentage": skill.percentage }}
                  ></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <AboutBox />
    </section>
  );
};

export default AboutPage;
